export enum VendorType {
    TDDA = 1,
	Healthtick = 2
  }
  